export default __webpack_public_path__ + "static/media/categorie_icons_Change_of_Planning.92fc19cc.svg";